export default "__VITE_ASSET__9a950bec__"